<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Notícias" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
   <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
  <section class="content">
    <!-- Default box -->
    <div class="card">
      <div class="card-body">
        <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
          <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
          <b-spinner class="ml-2" variant="danger"></b-spinner>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12">
            <div class="card bg-light d-flex flex-fill">
              <div class="card-header border-bottom-0">
                <h4 class="card-title titulos-conteudo">{{noticia.title}}</h4>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-12">
                    <p class="text-muted text-justify text-md textos" v-html="noticia.text"></p>
                  </div>
                  <div class="col-12">
                    <small class="text-muted">{{noticia.author}} - <a v-bind:href="noticia.source_link" target="_blank">{{noticia.source}} <i class="fas fa-external-link-alt"></i></a></small>
                  </div>
                  <div class="col-12">
                    <small class="text-muted">Publicado por: <strong>{{noticia.author}}</strong> em: {{formatarDataHora(noticia.date)}}</small>
                  </div>
                </div>
              </div>
              <div class="card-footer text-right">
                <b-button class="botoes" variant="outline-primary btn-sm mt-2" @click="voltarRotaAnterior()" :disabled="flagsDeControle.carregandoDados.status">Cancelar</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
  </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</div>
<!-- ./wrapper -->
</template>

<script>
import Detalhes from './js/detalhes-noticias'
export default Detalhes
</script>

<style scoped>
@import "./scss/noticias.scss";
</style>
